export default {
  /* Global */
  documentation: 'Documentation (German)',
  copied: 'Successfully Copied. (German)',
  copyFailed: 'Copy failed. (German)',
  login: 'Log in (German)',
  logout: 'Log out (German)',
  privacyPolicyConfirmation:
    "Please confirm you've read and understood our Privacy Policy on data use and protection. (German)",

  /* MainNavigation */
  products: 'Products (German)',
  governance: 'Governance (German)',
  organizations: 'Organizations (German)',
  organization: 'Organization (German)',
  reports: 'Reports (German)',
  compute: 'Compute (German)',
  myProducts: 'My products (German)',
  productSpecification: 'Product Specification (German)',
  order: 'Order (German)',
  freeTrial: 'Free Trial (German)',
  safescarf: 'SafeSCARF (German)',
  myInstance: 'My instance (German)',
  caas: 'CaaS (German)',
  myClusters: 'My Clusters (German)',
  monitoring: 'Monitoring (German)',
  myDashboards: 'My dashboards (German)',
  helpFeedback: 'Support & Feedback (German)',

  /* SidenNavigation */
  overview: 'Overview (German)',
  users: 'Users (German)',
  businessUnits: 'Business Units (German)',
  projects: 'Projects (German)',
  monitoringDashboards: 'Monitoring Dashboards (German)',
  tenants: 'Tenants (German)',
  hypervisors: 'Hypervisors (German)',
  juiceGroups: 'JuiceGroups (German)',
  caasCluster: 'Caas Clusters (German)',
  tdiConnectPortal: 'TDI Connect Portal (German)',
  profile: 'Profile (German)',
  notifications: 'Notifications (German)',
  security: 'Security (German)',

  /* Reports Page */
  tenantsReportTableMessage:
    'No tenant reports available. Please select a cloud from the dropdown.',
  hypervisorsTableMessage: 'No hypervisors available. Please select a cloud from the dropdown.',

  /* Feedback Page */
  feedbackSuccess: 'Feedback sent successfully! (German)',
  attachmentSizeError:
    'Total file size exceeds 2MB limit. Please reduce the number or size of files. (German)',
  feedbackTitle: 'Support & Feedback (German)',
  feedbackDescription:
    'We value your feedback. Please share your thoughts, suggestions, or report any issues. (German)',

  /* Table */
  emptyTable: 'No records to display. (German)',

  /* Delete Modal */
  deleteMessage1: 'Are you sure you want to delete this {name}? (German)',
  deleteMessage2: 'Type in the following to confirm: (German)',

  /* Cookie Banner */
  cookieBannerTitle: 'Cookie Usage (German)',
  cookieBannerCheckboxMessage1:
    'By checking this box, you confirm that you have read & understood our (German)',
  cookieBannerCheckboxMessage2:
    ', which explains how we collect, use, and protect your personal data. (German)',

  /* Home Page */
  title: 'TDI Connect (German)',
  iaasDescription:
    'Empower IT & Telco with Cloud Services for Scalable, Efficient Operations Across Europe (German)',
  computeTitle: 'Compute',
  computeSubheader: 'Scalable Compute for Any Workload',
  computeDescription:
    'Effortlessly deploy and scale high-performance compute resources in the cloud. Designed for demanding workloads like AI, data processing, and simulation — with fast provisioning, flexible pricing, and global availability.',
  computeButtonText: 'Read the Compute specs',
  caasTitle: 'CaaS',
  caasSubheader: 'Container as a Service',
  caasDescription:
    'Offers a managed environment for deploying and scaling containerized applications using Kubernetes clusters via API. Supports CaaS on OpenStack (VM-based clusters) or BareMetal (dedicated physical server clusters).',
  caasButtonText: 'Read the CaaS specs',
  safescarfTitle: 'SafeSCARF',
  safescarfDescription:
    'SafeSCARF offers scanning tools and vulnerability management for non-cloud environments, supporting multiple report formats with an easy-to-use interface and flexible free trials.',
  safescarfSubheader: 'Security single pane of glass',
  safescarfButtonText: 'Read the SafeSCARF specs',
  monitoringTitle: 'Monitoring',
  monitoringSubheader: 'Real-Time Insights with Grafana Dashboards',
  monitoringDescription:
    'Visualize system health and performance at a glance. Our integrated Grafana dashboards deliver real-time metrics, customizable alerts, and deep observability across your infrastructure.',
  monitoringButtonText: 'Read the Monitoring specs',
  marketPlaceText: 'Our Marketplace',
  /* api key */
  apiKeyGenerated: 'API key successfully generated (German)',
  apiKeyGenerationErr: 'API key generation failed (German)',
  apiKeyCopy1: 'Please copy this API key and store it in a safe place. (German)',
  apiKeyCopy2: 'You will not be able to see it again. (German)',

  /* users */
  userActivated: 'User was successfully activated. (German)',
  userPasswordChanged: 'Password was successfully changed. (German)',
  userPasswordMismatch: 'Passwords do not match. (German)',
  userPasswordResetEmail: 'Your password reset email has been sent. (German)',
  userPasswordReset: 'User password was successfully saved. Now you can log in. (German)',
  cloudPasswordUpdate: 'Cloud password was successfully updated. (German)',
  userCreation: 'User was successfully created. (German)',
  userDeleted: 'User was successfully deleted. (German)',
  userUpdated: 'User was successfully updated. (German)',
  userDeletePermissionErr: "You don't have a permission to delete this user. (German)",
  userEditPermissionErr: "You don't have a permission to edit this user. (German)",
  userUnassignment1: 'This user is assigned to the following products: (German)',
  userUnassignment2: 'By proceeding, the user will be unassigned from these products. (German)',
  incorrectToken: 'Incorrect token (German)',
  userActivationErr: 'User activation failed. (German)',
  userCreationPermissionErr: "You don't have the permission to create a new user. (German)",

  /* business units */
  businessUnitCreation: 'Business unit was successfully created. (German)',
  businessUnitUpdated: 'Business unit was successfully updated. (German)',
  businessUnitDeleted: 'Business unit was successfully deleted. (German)',
  businessUnitEditPermissionErr:
    "You don't have the permission to edit this business unit. (German)",
  businessUnitDeletePermissionErr:
    "You don't have the permission to delete this business unit. (German)",
  businessUnitCreatePermissionErr:
    "You don't have the permission to create new business unit. (German)",

  /* organizations */
  organizationCreation: 'Organization was successfully created. (German)',
  organizationUpdated: 'Organization was successfully updated. (German)',
  organizationCreationPermissionErr:
    "You don't have the permission to create a new organization. (German)",
  editOrganizationDisabled: "You don't have the permission to edit this organization. (German)",

  /* osprojects */
  createOsProjectFulfilled:
    'We are preparing your product in the data center. This operation will take a few minutes. You will be notified when the product is ready, and the service status will be shown as active. You can access all your active products (OpenStack projects) with one password per data center. This data center password is sent to you by e-mail when you create your first product (OpenStack project) in a respective data center. In case you did not receive an e-mail with a password, or you forgot your data center password, you can easily restore it in the portal (under Settings) – or contact our support team. (German)',
  osProjectNameDuplicate: 'This project name is already in use in the selected cloud. (German)',
  osProjectDeleted: 'Deletion succesfully started (German)',
  osProjectSetDeleted: 'Succesfully Deleted OsProject (German)',
  osProjectPatchFailed: 'Unable to set OsProject to deleted (German)',
  osProjectDeleteDisabled:
    "You don't have rights to set this OsProject to deleted. Please contact an admin user. (German)",
  osProjectDeleteDisabledCreatedFromJuice:
    'This osproject was created from juice and cannot be deleted. (German)',
  osProjectsDeleteMessage:
    'If you delete this Os Project, it will also be deleted from OpenStack. (German)',

  /* projects */
  projectCreation: 'Project was successfully created. (German)',
  projectDeleted: 'Project was successfully deleted. (German)',
  projectEdit: 'Project was successfully updated. (German)',
  noUsageData: 'There is no usage data. (German)',
  projectCreationPermissionErr: "You don't have the permission to create a new project. (German)",
  adminOrgActionDisabled: 'Not allowed in admin-org. (German)',
  editProjectDisabled: "You don't have the permission to edit this project. (German)",
  projectDeleteDisabled: 'Project cannot be deleted. (German)',
  projectDeleteDisabledHasProducts: 'Cannot delete project with existing products. (German)',

  /* products */
  productForecasts: 'Product {name} forecasts. (German)',
  productCreationPermissionErr: "You don't have the permission to create a new product. (German)",
  evaluationProductCreationDisabled: "You can't create new evaluation product. (German)",
  productCreation: 'Product was successfully created. (German)',
  productUpdated: 'Product was successfully updated. (German)',
  productDeleted: 'Product was successfully deleted. (German)',
  productDeleteDisabled:
    "You don't have rights to delete this product. Please contact admin user. (German)",
  productDeleteUndoable: "This type of product can't  be deleted. (German)",
  productDeleteDisabledOsProjects: 'There are existing OsProjects in this product. (German)',
  productDeleteDisabledCaasClusters: 'There are existing CaaS Clusters in this product. (German)',
  productDeleteDisabledCaasBm: 'Product with type caasonbaremetal is not deletable. (German)',
  editProductDisabled: "You don't have the permission to edit this product. (German)",
  productDeleteMessage:
    'If you delete this product, the juice group associated with it will also be deleted. (German)',

  /* Compute Order Text for Project and Resource Allocation */
  projectName: 'A user-friendly name identifying the OS Project. (German)',
  projectDescription:
    'The initiative or activity of your organization. Projects can be created only by Admins. (German)',
  productDescription:
    'Child of a Project that requires you to instantiate cloud resources. Products can be created only by Admins. (German)',
  dataCenterDescription:
    'TDI-operated data centers in Europe, compliant with DT standards and organized in a geo-redundant location concept. (German)',
  virtualCPUsAndMemory:
    'Amounts to be allocated to your OpenStack project. The vCPUs are offered with a standard processing performance. In case you require high performance processing, please reach out to our support team. (German)',

  /* forecasts */
  forecastsNotFound:
    'There is no information in forecast DB for this Juice Group, you cannot create virtual cloud for this project. (German)',
  forecastsApplySuccess: 'Forecast(s) are successfully applied. (German)',
  forecastsApplyFailure: 'Forecast(s) applying failed. (German)',

  /* juiceGroup  info */
  editJuiceGroupInfo: 'Edit JuiceGroup info. (German)',
  geoRedundancySet: 'Geo redundancy was successfully set. (German)',
  serviceAdded: 'External service was successfully added. (German)',
  serviceRemoved: 'External service was successfully removed. (German)',

  /* contact info */
  contactAdded: 'Contact information was successfully added. (German)',
  contactEdited: 'Contact information was successfully updated. (German)',
  contactRemoved: 'Contact information was successfully removed. (German)',
  contactCreateDisabled: "You don't have rights to create contact. (German)",
  contactEditDisabled: "You don't have rights to edit contact. (German)",
  contactDeleteDisabled: "You don't have rights to delete contact. (German)",

  /* safescarf */
  safescarfStatusLabel: 'The progress of your SafeSCARF instance deployment is: (German)',
  safescarfMachineAccountCreated:
    'Your new Machine Account has been created with the following username: (German)',

  safescarfProductTypeCreated: 'Product type was successfully created. (German)',
  safescarfProductTypeUpdated: 'Product type was successfully updated. (German)',
  createProductTypeDisabled: 'You are not entitled to create a new product type. (German)',
  editProductTypeDisabled: 'You are not entitled to edit this product type. (German)',

  safescarfProductTypeMemberUpdated: 'Product type member was successfully updated. (German)',
  editProductTypeMemberDisabled: 'You are not entitled to edit this product type member. (German)',
  editProductTypeMemberNotificationTitle:
    'Permissions granted at the product type level are inherited by all products within that product type. (German)',
  editProductTypeMemberNotificationText:
    'For example, users with Maintainer permission have maintainer permissions in all products of this product type. (German)',

  safescarfProductCreated: 'Product was successfully created. (German)',
  safescarfProductUpdated: 'Product was successfully updated. (German)',
  safescarfProductDeleted: 'Product was successfully deleted. (German)',
  safescarfProductDeleteDisabled: "You don't have rights to delete this product. (German)",
  createProductDisabled: 'You are not entitled to create a new product. (German)',
  editSafescarfProductDisabled: 'You are not entitled to edit this product. (German)',

  safescarfProductMemberUpdated: 'Product member was successfully updated. (German)',
  editProductMemberDisabled: 'You are not entitled to edit this product member. (German)',

  /* Notification Messages */
  defaultErrorMessage: 'Something went wrong. (German)',
  duplicateContactValidation: 'Ein Kontakt mit dieser E-Mail-Adresse und Rolle existiert bereits.',

  /* Errors */
  ERR_BAD_REQUEST: 'Bad request. (German)',
  ERR_NOT_FOUND: 'Not found. (German)',
  ERR_DUPLICATION: 'Duplication error. (German)',
  ERR_INPUT_VALIDATION: 'Input validation failure. (German)',
  ERR_UNAUTHORIZED: 'Not authorized. (German)',
  ERR_USER_DELETION_NOT_ENTITLED: "User doesn't have rights to delete that user role. (German)",
  ERR_FORBIDDEN: 'Forbidden. (German)',
  ERR_VERIFICATION_TOKEN: 'Verification token mismatch or user not found. (German)',
  ERR_INTERNAL_SERVER_ERROR: 'Internal Server Error. (German)',
  ERR_NAME_INVALID:
    'Name must contain only lowercase letters, numbers, and hyphens (e.g., my-project). (German)',
  ERR_ORG_NAME_INVALID:
    'Organization name must contain only lowercase letters, numbers, and hyphens (e.g., my-org). (German)',
  ERR_PASSWORD_INVALID:
    'Your password should have at least, 10 characters, 1 uppercase, 1 lowercase, 1 digit and 1 special character (no space). (German)',
  ERR_PASSWORD_DUPLICATE: 'You cannot re-use the current password. (German)',
  ERR_EMAIL_FAILED: 'User creation failed. (German)',
  ERR_MARKETPLACE_ITEM_NOT_ENABLED: 'Marketplace item not enabled. (German)',
  ERR_EXISTING_PRODUCTS: 'Cannot proceed because of existing products. (German)',
  ERR_EXISTING_TENANT: 'Cannot proceed because of existing tenants. (German)',
  ERR_ITEM_ALREADY_ACTIVATED: 'The selected marketplace item is already active. (German)',
  ERR_JUICEGROUP_INVALID_LENGTH:
    'The Juice Group name must be between 3 and 64 characters. (German)',
  ERR_JUICEGROUP_INVALID: 'The Juice Group Name is invalid. (German)',
};
